/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MarkPatientTargetAsDeleted$Params {
  patientTargetID?: number;
  propagate?: boolean;
}

export function MarkPatientTargetAsDeleted(http: HttpClient, rootUrl: string, params?: MarkPatientTargetAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, MarkPatientTargetAsDeleted.PATH, 'post');
  if (params) {
    rb.query('patientTargetID', params.patientTargetID, {});
    rb.query('propagate', params.propagate, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

MarkPatientTargetAsDeleted.PATH = '/api/Supervisor/MarkPatientTargetAsDeleted';
